var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "full-height" },
    [
      _c("saleer-create-or-update-dialog", {
        attrs: {
          visible: _vm.dialogVisibleBySaleer,
          "initial-form-data": _vm.formDataBySaleer,
          "auth-edit": _vm.authEdit,
          "agency-code": _vm.formDataBySaleer.agencyCode,
          "agency-list": _vm.agencyList,
        },
        on: {
          "update:visible": function ($event) {
            _vm.dialogVisibleBySaleer = $event
          },
          "update:initialFormData": function ($event) {
            _vm.formDataBySaleer = $event
          },
          "update:initial-form-data": function ($event) {
            _vm.formDataBySaleer = $event
          },
          save: _vm.handleDialogSaveBySaleer,
          closed: _vm.handleDialogCloseBySaleer,
        },
      }),
      _c(
        "el-form",
        {
          staticClass: "filter-form",
          attrs: { inline: true },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "查詢" } },
            [
              _c("el-input", {
                attrs: { placeholder: "輸入旅行社代碼/業務員暱稱/業務員姓名" },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.getList($event)
                  },
                },
                model: {
                  value: _vm.listQuery.search.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.listQuery.search, "name", $$v)
                  },
                  expression: "listQuery.search.name",
                },
              }),
            ],
            1
          ),
          _c("el-button", {
            staticStyle: { "margin-top": "8px", "margin-left": "5px" },
            attrs: {
              type: "primary",
              icon: "el-icon-search",
              circle: "",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.getList },
          }),
          _c("el-button", {
            attrs: {
              type: "warning",
              circle: "",
              icon: "el-icon-plus",
              disabled: _vm.listLoading,
            },
            on: { click: _vm.handleCreateSaleer },
          }),
          _c("el-button", {
            staticStyle: { cursor: "pointer" },
            attrs: {
              type: "success",
              loading: _vm.listLoading,
              circle: "",
              icon: "el-icon-refresh-left",
            },
            on: {
              click: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "formDetailsTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
              on: { "sort-change": _vm.sortChange },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "手機號碼", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.mobile))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "業務員姓名", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.name))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "業務員暱稱", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [_c("span", [_vm._v(_vm._s(row.nickName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作", width: "160" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: _vm.authEdit ? "success" : "info",
                              size: "mini",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleEditSaleer(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.authEdit ? "編輯" : "查看") + " "
                            ),
                          ]
                        ),
                        _vm.authEdit
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "danger", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDeleteSaleer(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 刪除 ")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }